import React from "react";

import PropTypes from "prop-types";

import { Popover } from "shared/components/Popover";
import Tag from "shared/components/Tag";
import Well from "shared/components/Well";
import { COLORS } from "shared/config/constants";
import { useEllipsisTooltip } from "shared/hooks";

import {
  TEAM_NOTE_LABEL,
  IDFRAUDRISK_VERIFIED_LABEL,
  systemAuditPropType,
  SYSTEM_AUDIT_NOTE_TAG,
  SYSTEM_AUDIT_IDFRAUDRISK_VERIFIED_TAG,
} from "../config";

import { PopoverContent, Title } from "./styled";

const ActivityTitle = ({ audit, index }) => {
  const { note, description, tag } = audit;
  const isTeamNote = tag === SYSTEM_AUDIT_NOTE_TAG.id;
  const isIdFraudRiskVerified =
    tag === SYSTEM_AUDIT_IDFRAUDRISK_VERIFIED_TAG.id;
  // `note` is the meaningful content only for team notes (or legacy audits with
  // no description). System audits put a technical JSON payload in `note`, which
  // must not leak into the activity feed — show the friendly `description` copy.
  const showNoteContent = isTeamNote || !description;
  const title = showNoteContent ? note || description : description;
  const { elementRef: activityRef, tooltipTitle: isOverflowed } =
    useEllipsisTooltip({ title });

  return (
    <Title>
      <Popover
        disabled={!isOverflowed}
        // @ts-ignore
        trigger="hover"
        content={
          <PopoverContent>
            <p className="popover-title">{description || TEAM_NOTE_LABEL}</p>
            {showNoteContent && !!note && (
              <Well className="popover-items">
                {note.split("\n").map((line) => (
                  <div key={line}>
                    <span>{line}</span>
                    <br />
                  </div>
                ))}
              </Well>
            )}
          </PopoverContent>
        }
      >
        <span
          className="title-span"
          data-testid={`unit-${index}-activity`}
          ref={activityRef}
        >
          {title}
        </span>
      </Popover>
      {isTeamNote && (
        <Tag
          className="note-tag"
          backgroundColor={COLORS.violetTheme.lightBlueViolet}
          color={COLORS.violetTheme.white}
        >
          {TEAM_NOTE_LABEL}
        </Tag>
      )}
      {isIdFraudRiskVerified && (
        <Tag
          className="note-tag"
          data-testid={`unit-${index}-activity-verified-tag`}
          backgroundColor={COLORS.violetTheme.green}
          color={COLORS.violetTheme.white}
        >
          {IDFRAUDRISK_VERIFIED_LABEL}
        </Tag>
      )}
    </Title>
  );
};

ActivityTitle.propTypes = {
  audit: systemAuditPropType,
  index: PropTypes.number.isRequired,
};

ActivityTitle.defaultProps = {
  audit: undefined,
};

export default ActivityTitle;
